import request from '@/utils/request';

// 1. 获取我的订单数据
export function fetchMyOrderList(params) {
  return request({
    url: '/ajax/enterprises/' + params.eid + '/orders',
    method: 'get',
    params: params
  });
}
// 2. 获取我的订单详情数据
export function fetchMyOrderInfo(params) {
  return request({
    url: '/ajax/enterprises/' + params.eid + '/orders/' + params.order_id,
    method: 'get'
  });
}
// 3. 关闭我的订单数据
export function closeMyOrder(data) {
  return request({
    url: '/ajax/enterprises/' + data.eid + '/orders/' + data.order_id + '/close',
    method: 'PUT',
    data
  });
}

// 4. 获取我的订单详情数据状态
export function fetchMyOrderInfoState(data) {
  return request({
    url: '/ajax/enterprises/' + data.eid + '/orders/' + data.order_id + '/events',
    method: 'get'
  });
}

export function OrderAppInstall(data) {
  return request({
    url: '/ajax/enterprises/' + data.eid + '/orders/' + data.order_id + '/install',
    method: 'post'
  });
}




// WEBPACK FOOTER //
// ./src/api/myOrder.js